import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { TuiBlockStatusModule } from '@taiga-ui/layout';

@Component({
    selector: 'us-empty',
    standalone: true,
    imports: [TranslocoModule, TuiBlockStatusModule],
    templateUrl: './empty.component.html',
    styleUrls: ['./empty.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmptyComponent {
    @Input() title?: string;
}
